import { formatHours } from "@/pages/projekte/hoursUsage";
import type { BookedHoursEntry } from "@/pages/projekte/useBookedHours";

interface BookedHoursCellProps {
  entry?: BookedHoursEntry;
}

export function BookedHoursCell({ entry }: BookedHoursCellProps) {
  if (!entry || entry.loading) {
    return <span className="text-label-tertiary">…</span>;
  }
  if (entry.error) {
    return (
      <span className="text-label-tertiary" title="Gebuchte Stunden konnten nicht geladen werden">
        —
      </span>
    );
  }
  if (entry.hours == null || !Number.isFinite(entry.hours)) {
    return <span className="text-label-tertiary">—</span>;
  }
  return (
    <span className="tabular-nums" title="Hero + Nachunternehmer">
      {formatHours(entry.hours)}
    </span>
  );
}
